module.exports = __webpack_public_path__ + "static/media/couchcast_logo.d63cdcfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/couchcast_logo.png
// module id = 14
// module chunks = 0